module.exports = __webpack_public_path__ + "637ca3d72f73f9fede471c7f9ac800fb.ttf";